/** Function that sorts arrays or Float64Arrays in ascending order
 *
 * @param array - array to sort
 * @returns sorted array
 */
export function xSortAscending(array) {
    if (array instanceof Float64Array) {
        return array.sort();
    }
    else if (Array.isArray(array)) {
        return array.sort((a, b) => a - b);
    }
    throw new Error('Trying to sort non aray');
}
/** Function that sorts arrays or Float64Arrays in descending order
 *
 * @param array - array to sort
 * @returns sorted array
 */
export function xSortDescending(array) {
    if (array instanceof Float64Array) {
        return array.sort().reverse();
    }
    else if (Array.isArray(array)) {
        return array.sort((a, b) => b - a);
    }
    throw new Error('Trying to sort non aray');
}
//# sourceMappingURL=xSort.js.map